<template>
     <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Editar fecha de vencimiento
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <h6 class="mb-2"><strong>{{row.concepto}}</strong></h6>
            <vs-col class="mt-2" vs-justify="center" vs-align="center" w="12">
                <label for="actual">Fecha de vencimiento</label>
                <vs-input
                    type="date"
                    v-model="row.vencimiento"
                    disabled
                />
            </vs-col>
            <vs-col class="mt-2" vs-justify="center" vs-align="center" w="12">
                <label for="actual">Nueva fecha de vencimiento</label>
                <vs-input
                    type="date"
                    v-model="fecha_vencimiento"
                >
                    <template #message-danger v-if="errorFields.includes('fecha_vencimiento')">
                        Requerido
                    </template>
                </vs-input>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="close">
              Cancelar
            </vs-button>
            <vs-button block success @click="postEditarFecha()">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
    ],
    data () {
        return {
            active: false,
            fecha_vencimiento: '',
            errorFields:[]
        }
    },
    methods: {
      sanityForm () {
            this.errorFields = []
            if (!this.fecha_vencimiento) {
                this.errorFields.push('fecha_vencimiento')
            }
            if (!this.errorFields.length){
                
                const formData = new FormData()
                    formData.append('movimiento_id', this.row.movimiento_id)
                    formData.append('fecha_vigencia', this.fecha_vencimiento)
                    formData.append('action', 'fecha_vencimiento_cobro')
                return formData
            } else {
                return null
            }
        },
        async postEditarFecha () {
                const datos = this.sanityForm()
            if(datos){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await profesor.postEditarFecha(datos)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa'
                    })
                    this.active = false
                    this.fecha_vencimiento = ''
                    this.$emit('refreshTable')
                    loading.close()
                } catch(error) {
                    loading.close()
                }
            }
        },
        async close () {
            this.active = false
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>